exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-borde th[data-v-382932c8]{padding:12px 6px;text-align:center}.many-field-tr td[data-v-382932c8]{padding:6px}.td-btn[data-v-382932c8]{cursor:pointer}.td-btn[data-v-382932c8]:hover{background-color:#caf6ec;font-weight:700;font-size:1rem;color:$primary}.prod-list-page-selected[data-v-382932c8]{color:#18a4ed}.prod-list-page-not-selected[data-v-382932c8]{color:#666}.primary[data-v-382932c8]{color:$primary}.prod-tag[data-v-382932c8]{background-color:#ebab39;display:inline-block;padding:4px 10px;color:#fff;border-radius:3px;margin:2px}.prod-search-bgcolor[data-v-382932c8]{background-color:#f1f7f8}", ""]);

// exports
